//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TargetQuality {
	Low = 0,
	Medium = 1,
	High = 2,
	VeryHigh = 3
}
